import React from 'react'
import LiveModal from 'live/components/ui/Modal'
import { Modal } from 'react-bootstrap'
import i18n from 'live/services/i18n'
import SubmitOrCancel from 'live/components/forms/ui/submit-or-cancel'

interface Props {
    show: boolean,
    title: string,
    body: string,
    footerMessage: string,
    onSubmit: Function,
    onCancel: Function
}

const ConfirmationModal: React.FC<Props> = props => {
    const { show, title, body, footerMessage, onSubmit, onCancel } = props

    return (
        <LiveModal show={show}>
            <Modal.Header>
                <Modal.Title>{i18n(title)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <label>
                    {i18n(body)}
                </label>
            </Modal.Body>
            <Modal.Footer>
                <SubmitOrCancel
                    buttonMessage={footerMessage}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                />
            </Modal.Footer>
        </LiveModal>
    )
}

export default ConfirmationModal
